import SaudeDaMulherIcon from '@/components/icons/IndicadoresAps/eSFeAP/SaudeDaMulher.vue'

export default {
  value: 'c7',
  label: 'Saúde mulher',
  iconType: 'component',
  iconComponent: SaudeDaMulherIcon,
  buscaAtiva: {
    // a: ({ cidadao, formatDate }) =>
    //   `Cidadão ${cidadao?.no_cidadao || '-'} nascido em ${
    //     cidadao?.dt_nascimento ? formatDate(cidadao.dt_nascimento) : '-'
    //   }.`,
    a: 'Essa pessoa terá 25 anos ou mais ao final do quadrimestre avaliado e está sem coleta, solicitação ou avaliação de pelo menos 01 exame de rastreamento para câncer do colo de útero nos últimos 36 meses.',
    b: 'Criança terá 9 anos ou mais até o final do quadrimestre avaliado.  Recomenda-se programar a vacina dela conforme o calendário de vacinação atual.',
    c: 'Pessoa sem consulta médica ou de enfermagem sobre atenção à saúde sexual e reprodutiva nos últimos 12 meses.',
    d: 'Essa pessoa terá 50 anos ou mais até no final do quadrimestre avaliado e ainda não tem pelo menos 01 exame de rastreamento para câncer de mama, solicitado ou avaliado nos últimos 24 meses.',
  },
}
